/**
 * Error sampling utilities for Sentry
 * Centralized logic for sampling different types of errors
 */

/**
 * Checks if an event is a Google Maps API load error
 * for ex. happens periodically when trying to load google geocoder
 */
const isGoogleMapsApiError = (event) =>
  event.exception?.values?.[0]?.value === "The Google Maps JavaScript API could not load." &&
  event.exception?.values?.[0]?.stacktrace?.frames?.some((frame) =>
    frame.filename?.includes("@googlemaps/js-api-loader"),
  );

/**
 * Checks if an event is an iOS Safari ES6 module loading error
 * "TypeError: Importing a module script failed."
 *
 * This error is 97.4% iOS devices and 80.6% Mobile Safari browsers.
 * Caused by iOS Safari bugs with ES6 dynamic imports, network issues loading module chunks,
 * or aggressive Safari caching of stale module files.
 */
const isIOSSafariModuleError = (event) => event.exception?.values?.[0]?.value === "Importing a module script failed.";

/**
 * Applies sampling rules to events before they're sent to Sentry
 * Returns the event if it should be sent, null if it should be dropped
 */
export const applySamplingRules = (event) => {
  if (isGoogleMapsApiError(event)) {
    return Math.random() < 0.05 ? event : null;
  }

  if (isIOSSafariModuleError(event)) {
    return Math.random() < 0.05 ? event : null;
  }

  return event;
};
